export default __webpack_public_path__ + "static/media/caret-up.b048fc4a.svg";